import {
  superAdminDelete,
  superAdminGet,
  superAdminPatch,
  superAdminPost,
  superAdminPut,
  superAdminUpload,
} from "./superadmin-api";

export const buildTenantQuery = ({
  search = "",
  active = "",
  page = 0,
  size = 20,
}) => {
  const params = new URLSearchParams();
  if (search.trim() !== "") {
    params.set("search", search.trim());
  }
  if (active !== "") {
    params.set("active", active);
  }
  params.set("page", page);
  params.set("size", size);
  return params.toString();
};

export const loginSuperAdmin = (credentials) => {
  return superAdminPost("su/admin/login", credentials, false);
};

export const listSuperAdminTenants = (filters = {}) => {
  return superAdminGet(`su/admin/tenants?${buildTenantQuery(filters)}`);
};

export const createSuperAdminTenant = (payload) => {
  return superAdminPost("su/admin/tenants", payload);
};

export const getSuperAdminTenant = (tenantCode) => {
  return superAdminGet(`su/admin/tenants/${tenantCode}`);
};

export const updateSuperAdminTenant = (tenantCode, payload) => {
  return superAdminPatch(`su/admin/tenants/${tenantCode}`, payload);
};

export const createSuperAdminTenantAdmin = (tenantCode, payload) => {
  return superAdminPost(`su/admin/tenants/${tenantCode}/admins`, payload);
};

export const getSuperAdminTenantConfig = (tenantCode) => {
  return superAdminGet(`su/admin/tenants/${tenantCode}/config`);
};

export const updateSuperAdminTenantConfig = (tenantCode, payload) => {
  return superAdminPut(`su/admin/tenants/${tenantCode}/config`, payload);
};

export const getSuperAdminTenantModules = (tenantCode) => {
  return superAdminGet(`su/admin/tenants/${tenantCode}/modules`);
};

export const updateSuperAdminTenantModule = (
  tenantCode,
  moduleKey,
  enabled
) => {
  return superAdminPut(
    `su/admin/tenants/${tenantCode}/modules/${moduleKey}`,
    { enabled }
  );
};

export const uploadSuperAdminTenantLogo = (tenantCode, file) => {
  const formData = new FormData();
  formData.append("logo", file);
  return superAdminUpload(
    `su/admin/tenants/${tenantCode}/branding/logo`,
    formData
  );
};

export const getSuperAdminTenantFirebaseConfig = (tenantCode) => {
  return superAdminGet(`su/admin/tenants/${tenantCode}/firebase`);
};

export const updateSuperAdminTenantFirebaseConfig = (tenantCode, payload) => {
  return superAdminPut(`su/admin/tenants/${tenantCode}/firebase`, payload);
};

export const deleteSuperAdminTenantFirebaseConfig = (tenantCode) => {
  return superAdminDelete(`su/admin/tenants/${tenantCode}/firebase`);
};
